import { applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

export const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];
if (
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_ENABLE_REDUX_LOGGGER === 'true'
) {
  middlewares.push(createLogger());
}

export default applyMiddleware(...middlewares);
